"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import r, { useMemo as f } from "react";
import { useId as P } from '../../hooks/use-id.js';
import { DisabledProvider as y, useDisabled as u } from '../../internal/disabled.js';
import { FormFieldsProvider as D } from '../../internal/form-fields.js';
import { IdProvider as v } from '../../internal/id.js';
import { forwardRefWithAs as b, useRender as E } from '../../utils/render.js';
import { useDescriptions as A } from '../description/description.js';
import { useLabels as L } from '../label/label.js';
let _ = "div";
function c(d, l) {
  let t = "headlessui-control-".concat(P()),
    [s, p] = L(),
    [n, a] = A(),
    m = u(),
    {
      disabled: e = m || !1
    } = d,
    i = _objectWithoutProperties(d, _excluded),
    o = f(() => ({
      disabled: e
    }), [e]),
    F = {
      ref: l,
      disabled: e || void 0,
      "aria-disabled": e || void 0
    },
    T = E();
  return r.createElement(y, {
    value: e
  }, r.createElement(p, {
    value: s
  }, r.createElement(a, {
    value: n
  }, r.createElement(v, {
    id: t
  }, T({
    ourProps: F,
    theirProps: _objectSpread(_objectSpread({}, i), {}, {
      children: r.createElement(D, null, typeof i.children == "function" ? i.children(o) : i.children)
    }),
    slot: o,
    defaultTag: _,
    name: "Field"
  })))));
}
let H = b(c);
export { H as Field };